/**
 * Created by olga on 2026-05-18
 */

const SideQuestTutorial = function () {
    return new TutorialScenario(SideQuestTutorial.NAME, {
        manual: true,

        listSteps: SideQuestTutorial.listSteps,

        isAvailable: function () {
            return Merge2.current.field.findEmptySlot(0, 0);
        },

        onFinish: function () {
            delete SideQuestTutorial.GENERATOR;
        }
    });
};

SideQuestTutorial.listSteps = function () {
    if (!this.isAvailable() || !SideQuestTutorial.GENERATOR) {
        return [];
    }
    const config = OrdersAlgoConfig.generators[SideQuestTutorial.GENERATOR.code];
    const drops = config.stages[SideQuestTutorial.GENERATOR.stage].drop;
    const generatorCode = SideQuestTutorial.GENERATOR.code;
    return [
        new TutorialStep({
            onStart: function () {
                const customerView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable.rows.find((row) => row.data.customerIndex
                    && row.data.customerIndex === Merge2Customers.SIDE_QUEST_CUSTOMER_INDEX && !row.removed);
                if (customerView) {
                    this.finish();
                    return;
                }

                cleverapps.focusManager.display({
                    focus: "TutorialForce",
                    stack: true,
                    keepControls: true,
                    action: (f) => {
                        cleverapps.focusManager.showControlsWhileFocused(Merge2.current.getUpContainerControls());
                        cleverapps.eventBus.on("addRowAnimationFinish", () => {
                            f();
                            this.finish();
                        }, this);
                    }
                });
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        }),
        (function () {
            const bundle = `side_quest_tutorial_${generatorCode}`;
            const config = {
                dialogueConfig: bundles[bundle].jsons.dialogues_json,
                imageBundle: bundle
            };
            return Merge2TutorialHelper.createDialogueStep(config);
        }()),

        new TutorialStep({
            onStart: function () {
                const reward = { unit: SideQuestTutorial.GENERATOR };
                new RewardWindow(new RewardsList(reward, {
                    toBubbleStack: true
                }));

                cleverapps.tutorial.on("onPushBubbleStack", this.finish.bind(this), this);
            },

            onFinish: function () {
                Merge2.current.counter.trigger();
            }
        }),

        Merge2TutorialHelper.createBubbleStackStep({
            unit: SideQuestTutorial.GENERATOR,
            text: `SideQuestTutorial${generatorCode}.text0`
        }),

        Merge2TutorialHelper.createClickUnitStep({
            text: `SideQuestTutorial${generatorCode}.text1`,
            finishEvent: "onUnitSpawned",
            finishFilter: (unit) => Unit.Equals({ code: drops[0], stage: 0 }, unit),
            unit: SideQuestTutorial.GENERATOR
        }),

        Merge2TutorialHelper.createClickUnitStep({
            unit: {
                code: drops[0],
                stage: 0
            },
            finishEvent: "unitSelectionChanged",
            text: `SideQuestTutorial${generatorCode}.text2`
        }),
        Merge2TutorialHelper.createUnitsLibraryStep({
            text: `SideQuestTutorial${generatorCode}.text3`
        })
    ];
};

SideQuestTutorial.NAME = "side_quest";